import React from "react";
import { SideMenu, BackHeader, SimpleMap, Model } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import { MdDelete } from "react-icons/md";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import "./purchase-product-my-cart.css";
const PurchasesProductMyCart = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const [addMoney, setAddMoney] = React.useState(false);
  const [addNewCard, setAddNewCard] = React.useState(false);
  const [selectedPorductCounter, setSelectedPorductCounter] = React.useState(1);
  const [buyProcess, setBuyProcess] = React.useState(false);
  const [delivery, setDelevery] = React.useState("Delivery");
  const [time, setTime] = React.useState(2);
  const [addAddress, setAddAddress] = React.useState(false);
  const detailDecrementHandler = () => {
    if (selectedPorductCounter > 1) {
      setSelectedPorductCounter(selectedPorductCounter - 1);
    }
  };
  let Time = [
    {
      time: "10:00",
    },
    {
      time: "11:00",
    },

    {
      time: "12:00",
    },
    {
      time: "13:00",
    },
    {
      time: "14:00",
    },
  ];

  // Add Address
  const [addAddressTitle, setAddAddrssTitle] = React.useState("");
  const [addAddressOfficeNo, setAddAddrssOfficeNo] = React.useState("");
  const [addAddressCity, setAddAddrssCity] = React.useState("");
  const [addAddressDistrict, setAddAddrssDistrict] = React.useState("");
  const [addAddressAddress, setAddAddrssAddress] = React.useState("");
  const [addAddressLoading, setAddAddrssLoading] = React.useState(false);
  const addAddressTitleRef = React.useRef();
  const addAddressOfficeNoRef = React.useRef();
  const addAddressCityRef = React.useRef();
  const addAddressDistrictRef = React.useRef();
  const addAddressAddressRef = React.useRef();
  const AddAddressHandler = () => {
    if (addAddressTitle === "") {
      alert.error(<div className="alert-message">please add title</div>);
      addAddressTitleRef.current.focus();
    } else if (addAddressOfficeNo === "") {
      alert.error(
        <div className="alert-message">please add Apt./Office No</div>
      );
      addAddressOfficeNoRef.current.focus();
    } else if (addAddressCity === "") {
      alert.error(<div className="alert-message">please add city</div>);
      addAddressCityRef.current.focus();
    } else if (addAddressDistrict === "") {
      alert.error(<div className="alert-message">please add district</div>);
      addAddressDistrictRef.current.focus();
    } else if (addAddressAddress === "") {
      alert.error(<div className="alert-message">please add address</div>);
      addAddressAddressRef.current.focus();
    } else {
      setAddAddrssLoading(true);
      const AddAddressObject = {
        title: addAddressTitle,
        officeNo: addAddressOfficeNo,
        city: addAddressCity,
        district: addAddressDistrict,
        address: addAddressAddress,
      };
      alert.success(
        <div className="alert-message">you have successfully add address</div>
      );
      console.log(AddAddressObject);
      setTimeout(() => {
        setAddAddress(false);
        setAddAddrssLoading(false);
      }, 2000);
    }
  };

  // Add Money
  const [addMoneyCurrency, setAddMoneyCurrency] = React.useState("$");
  const [addMoneyAmount, setAddMoneyAmount] = React.useState("");
  const [addMoneyAmountMethod, setAddMoneyAmountMethod] = React.useState("");
  const [addMoneyLoading, setAddMoneyLoading] = React.useState(false);
  const addMoneyAmountRef = React.useRef();
  const addMoneyAmountMethodRef = React.useRef();
  const AddMoneyHandler = () => {
    if (addMoneyAmount === "") {
      alert.error(<div className="alert-message">please add your amount</div>);
      addMoneyAmountRef.current.focus();
    } else if (addMoneyAmountMethod === "") {
      alert.error(
        <div className="alert-message">please select amount method</div>
      );
      addMoneyAmountMethodRef.current.focus();
    } else {
      setAddMoneyLoading(true);
      const AddMoneyObject = {
        currency: addMoneyCurrency,
        amount: addMoneyAmount,
        method: addMoneyAmountMethod,
      };
      alert.success(
        <div className="alert-message">you have successfully add money</div>
      );
      console.log(AddMoneyObject);
      setTimeout(() => {
        setAddMoney(false);
        setAddMoneyLoading(false);
      }, 2000);
    }
  };

  // Add New Card
  const [cardHolderName, setCardHolderName] = React.useState("");
  const [accountNumber, setAccountNumber] = React.useState("");
  const [expiryDate, setExpiryDate] = React.useState("");
  const [cvv, setCvv] = React.useState("");
  const [addNewCardLoading, setAddNewCardLoading] = React.useState(false);
  const cardHolderNameRef = React.useRef();
  const accountNumberRef = React.useRef();
  const expiryDateRef = React.useRef();
  const cvvRef = React.useRef();
  const AddNewCardHandler = () => {
    if (cardHolderName === "") {
      alert.error(<div className="alert-message">name required</div>);
      cardHolderNameRef.current.focus();
    } else if (accountNumber === "" || accountNumber.length < 16) {
      alert.error(
        <div className="alert-message">please enter valid account number</div>
      );
      accountNumberRef.current.focus();
    } else if (expiryDate === "") {
      alert.error(
        <div className="alert-message">please select expiry date</div>
      );
      expiryDateRef.current.focus();
    } else if (cvv === "") {
      alert.error(<div className="alert-message">please add cvv</div>);
      cvvRef.current.focus();
    } else {
      setAddNewCardLoading(true);
      const AddNewCardObject = {
        name: cardHolderName,
        accountNumber: accountNumber,
        expiryDate: expiryDate,
        cvv: cvv,
      };
      alert.success(
        <div className="alert-message">you have successfully add new card</div>
      );
      console.log(AddNewCardObject);
      setTimeout(() => {
        setAddNewCard(false);
        setAddNewCardLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu purchseIcon={true}>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="purchase-product-my-cart-heading">My Cart</p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
              <div className="purchase-product-my-cart-card">
                <div className="purchase-product-my-cart-card-delete-section">
                  <Button>
                    <MdDelete color="#FF0000" size={25} />
                  </Button>
                </div>
                <div className="purchase-product-my-cart-card-image">
                  <img
                    src={
                      "https://media.istockphoto.com/photos/pen-picture-id1059543698?b=1&k=20&m=1059543698&s=170667a&w=0&h=XkV_uYBfIWrAfcblgHD3oH3I-Pu2L0gvxy9bmAq-jj0="
                    }
                    className="box-list-image"
                  />
                </div>
                <div className="purchase-product-my-cart-card-detail-main">
                  <p className="purchase-product-my-cart-card-detail-heading">
                    Classmate Octane Colour Burst -...
                  </p>
                  <div className="purchase-product-my-cart-card-detail-price-section">
                    <p className="purchase-product-card-price">$16.06</p>
                    <div className="purchase-product-card-inc-dec-main">
                      <button
                        className="purchase-product-card-inc-dec-button"
                        onClick={detailDecrementHandler}
                      >
                        -
                      </button>
                      <p className="purchase-product-card-selected-couonter">
                        {selectedPorductCounter}
                      </p>
                      <button
                        className="purchase-product-card-inc-dec-button"
                        onClick={() =>
                          setSelectedPorductCounter(selectedPorductCounter + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="purchase-product-my-cart-card">
                <div className="purchase-product-my-cart-card-delete-section">
                  <Button>
                    <MdDelete color="#FF0000" size={25} />
                  </Button>
                </div>
                <div className="purchase-product-my-cart-card-image">
                  <img
                    src={
                      "https://media.istockphoto.com/photos/pen-picture-id1059543698?b=1&k=20&m=1059543698&s=170667a&w=0&h=XkV_uYBfIWrAfcblgHD3oH3I-Pu2L0gvxy9bmAq-jj0="
                    }
                    className="box-list-image"
                  />
                </div>
                <div className="purchase-product-my-cart-card-detail-main">
                  <p className="purchase-product-my-cart-card-detail-heading">
                    Classmate Octane Colour Burst -...
                  </p>
                  <div className="purchase-product-my-cart-card-detail-price-section">
                    <p className="purchase-product-card-price">$16.06</p>
                    <div className="purchase-product-card-inc-dec-main">
                      <button
                        className="purchase-product-card-inc-dec-button"
                        onClick={detailDecrementHandler}
                      >
                        -
                      </button>
                      <p className="purchase-product-card-selected-couonter">
                        {selectedPorductCounter}
                      </p>
                      <button
                        className="purchase-product-card-inc-dec-button"
                        onClick={() =>
                          setSelectedPorductCounter(selectedPorductCounter + 1)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={12} sm={12} xs={12}></Grid>
            <Grid item xl={5} lg={5} md={12} sm={12} xs={12}>
              <div className="purchase-product-card-container">
                {!buyProcess ? (
                  <div>
                    <div className="purchase-product-promo-main">
                      <p className="purchase-product-promo-code-heading">
                        Promo Code
                      </p>
                      <p className="purchase-product-promo-code">AHS7562</p>
                    </div>
                    <div className="purchase-product-delivery-type-main">
                      <Button
                        className={
                          delivery === "Delivery"
                            ? "purchase-product-delivery-type-selected"
                            : "purchase-product-delivery-type-un-selected"
                        }
                        onClick={() => setDelevery("Delivery")}
                      >
                        Delivery
                      </Button>{" "}
                      <Button
                        className={
                          delivery === "Pickup"
                            ? "purchase-product-delivery-type-selected"
                            : "purchase-product-delivery-type-un-selected"
                        }
                        onClick={() => setDelevery("Pickup")}
                      >
                        Pickup
                      </Button>
                    </div>
                    <p className="input-heading">Select Date</p>
                    <input
                      type="date"
                      className="input"
                      placeholder="Select Date"
                    />
                    <p className="input-heading">Select Time</p>
                    <div className="purchase-product-delivery-time-main">
                      {Time.map((timeValue, TimeIndex) => {
                        return (
                          <Button
                            key={TimeIndex}
                            onClick={() => setTime(TimeIndex)}
                            className={
                              time === TimeIndex
                                ? "purchase-product-delivery-time-selected"
                                : "purchase-product-delivery-time-un-selected"
                            }
                          >
                            {timeValue.time}
                          </Button>
                        );
                      })}
                    </div>
                    {delivery === "Delivery" && (
                      <>
                        <div className="purchase-product-delivery-address-main">
                          <p className="purchase-product-delivery-address-heading">
                            Select Address
                          </p>
                          <a
                            href="#"
                            className="purchase-product-delivery-address-add"
                            onClick={() => setAddAddress(true)}
                          >
                            + Add New Address
                          </a>
                        </div>
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="home"
                            name="radio-buttons-group"
                          >
                            <div className="purchase-product-delivery-radio-main">
                              <FormControlLabel
                                value="home"
                                control={<Radio />}
                                label=""
                              />
                              <p className="purchase-product-delivery-radio-description">
                                <span className="purchase-product-delivery-radio-heading">
                                  Home
                                </span>{" "}
                                - 4152 Cessna Drive, United States
                              </p>
                            </div>
                            <div className="purchase-product-delivery-radio-main">
                              <FormControlLabel
                                value="other"
                                control={<Radio />}
                                label=""
                              />
                              <p className="purchase-product-delivery-radio-description">
                                <span className="purchase-product-delivery-radio-heading">
                                  Other
                                </span>{" "}
                                - 4152 Cessna Drive, United States
                              </p>
                            </div>
                          </RadioGroup>
                        </FormControl>
                      </>
                    )}
                    <div className="purchase-product-line" />
                    <div className="purchase-product-bill-main">
                      <p className="purchase-product-bill-title">Subtotal</p>
                      <p className="purchase-product-bill-price">$150</p>
                    </div>
                    <div className="purchase-product-bill-main">
                      <p className="purchase-product-bill-title">Tax (%)</p>
                      <p className="purchase-product-bill-price">$20</p>
                    </div>
                    <div className="purchase-product-bill-main">
                      <p className="purchase-product-bill-title">Delivery</p>
                      <p className="purchase-product-bill-price">$20</p>
                    </div>
                    <div className="purchase-product-bill-main">
                      <p className="purchase-product-bill-title">Discount</p>
                      <p className="purchase-product-bill-price">$20</p>
                    </div>
                    <div className="purchase-product-bill-main">
                      <p className="purchase-product-bill-title">
                        Total Amount
                      </p>
                      <p className="purchase-product-bill-total-price">
                        $170.00
                      </p>
                    </div>
                    <Button
                      className="form-button"
                      variant="text"
                      onClick={() => setBuyProcess(true)}
                    >
                      Buy Now
                    </Button>
                  </div>
                ) : (
                  <div>
                    <div className="purchase-product-my-cart-card-header">
                      <h1 className="purchase-product-my-cart-card-header-heading">
                        Wallet Balance
                      </h1>
                      <a
                        href="#"
                        className="purchase-product-my-cart-card-header-add-wallet"
                        onClick={() => setAddMoney(true)}
                      >
                        Add wallet balance
                      </a>
                    </div>
                    <input
                      type="number"
                      className="purchase-product-my-cart-card-price-input"
                      value="100.00"
                    />
                    <div className="purchase-product-my-cart-card-header">
                      <h1 className="purchase-product-my-cart-card-header-heading">
                        Cradit/dabit card
                      </h1>
                      <a
                        href="#"
                        className="purchase-product-my-cart-card-header-add-wallet"
                        onClick={() => setAddNewCard(true)}
                      >
                        Add Card
                      </a>
                    </div>
                    <br />
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="home"
                        name="radio-buttons-group"
                      >
                        <div className="purchase-product-delivery-radio-main">
                          <FormControlLabel
                            value="Visa"
                            control={<Radio />}
                            label=""
                          />
                          <div className="purchase-product-my-cart-card-radio-button-value">
                            <div>
                              <h1 className="purchase-product-my-cart-card-radio-button-heading">
                                Visa
                              </h1>
                              <p className="purchase-product-my-cart-card-radio-button-card-number">
                                1234 1234 1234 1234
                              </p>
                            </div>
                            <h1 className="purchase-product-my-cart-card-radio-button-price">
                              $100.00
                            </h1>
                          </div>
                        </div>
                        <br />
                        <div className="purchase-product-delivery-radio-main">
                          <FormControlLabel
                            value="Master Card"
                            control={<Radio />}
                            label=""
                          />
                          <div className="purchase-product-my-cart-card-radio-button-value">
                            <div>
                              <h1 className="purchase-product-my-cart-card-radio-button-heading">
                                Master card
                              </h1>
                              <p className="purchase-product-my-cart-card-radio-button-card-number">
                                1234 1234 1234 1234
                              </p>
                            </div>
                            <h1 className="purchase-product-my-cart-card-radio-button-price">
                              $100.00
                            </h1>
                          </div>
                        </div>
                        <br />
                        <div className="purchase-product-delivery-radio-main">
                          <FormControlLabel
                            value="Debit Card"
                            control={<Radio />}
                            label=""
                          />
                          <div className="purchase-product-my-cart-card-radio-button-value">
                            <div>
                              <h1 className="purchase-product-my-cart-card-radio-button-heading">
                                Debit card
                              </h1>
                              <p className="purchase-product-my-cart-card-radio-button-card-number">
                                1234 1234 1234 1234
                              </p>
                            </div>
                            <h1 className="purchase-product-my-cart-card-radio-button-price">
                              $100.00
                            </h1>
                          </div>
                        </div>
                      </RadioGroup>
                    </FormControl>
                    <div className="purchase-product-my-cart-card-footer">
                      <div>
                        <p className="purchase-product-my-cart-card-footer-heading">
                          Total pay
                        </p>
                        <h1 className="purchase-product-my-cart-card-footer-price">
                          $20
                        </h1>
                      </div>
                      <Button
                        onClick={() => navigate("/purchases-product/message")}
                      >
                        <p className="purchase-product-my-cart-card-footer-continue-button-text">
                          Continue
                        </p>
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
      <Model
        modelTitle="Add Address"
        onClose={() => setAddAddress(false)}
        open={addAddress}
        buttonTitle="Add Address"
        buttonHandler={AddAddressHandler}
        loading={addAddressLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <SimpleMap />
                </div>
              </Grid>
            </Grid>
            <br />
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Title</p>
                  <input
                    type="text"
                    name="title"
                    className="input"
                    placeholder="Add Title"
                    value={addAddressTitle}
                    ref={addAddressTitleRef}
                    onChange={(e) => setAddAddrssTitle(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Apt./Office No.</p>
                  <input
                    type="number"
                    name="number"
                    className="input"
                    placeholder="Apt./Office No."
                    value={addAddressOfficeNo}
                    ref={addAddressOfficeNoRef}
                    onChange={(e) => setAddAddrssOfficeNo(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">City</p>
                  <input
                    type="text"
                    name="city"
                    className="input"
                    placeholder="City"
                    value={addAddressCity}
                    ref={addAddressCityRef}
                    onChange={(e) => setAddAddrssCity(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">District</p>
                  <input
                    type="text"
                    name="district"
                    className="input"
                    placeholder="District"
                    value={addAddressDistrict}
                    ref={addAddressDistrictRef}
                    onChange={(e) => setAddAddrssDistrict(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Address</p>
                  <input
                    type="text"
                    name="address"
                    className="input"
                    placeholder="Address"
                    value={addAddressAddress}
                    ref={addAddressAddressRef}
                    onChange={(e) => setAddAddrssAddress(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
      <Model
        modelTitle="Add money"
        width="md"
        onClose={() => setAddMoney(false)}
        open={addMoney}
        buttonTitle="Submit"
        buttonHandler={AddMoneyHandler}
        loading={addMoneyLoading}
      >
        <div className="form-container">
          <div className="my-wallet-add-money-model">
            <p className="my-wallet-add-money-model-username">David Anderson</p>
            <div className="my-wallet-add-money-model-price-main">
              <p className="my-wallet-add-money-model-heading">
                wallet balance
              </p>
              <p className="my-wallet-add-money-model-price">$65,000</p>
            </div>
          </div>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">add Amount</p>
                  <div className="country-code-picker-main">
                    <div className="country-code-picker-dropdown-main">
                      <select
                        className="country-code-picker-dropdown"
                        onChange={(e) => setAddMoneyCurrency(e.target.value)}
                      >
                        <option value="$">$</option>
                        <option value="£">£</option>
                        <option value="€">€</option>
                      </select>
                    </div>
                    <div className="country-flag-main">
                      <input
                        type="number"
                        name="amount"
                        className="mobile-number-input"
                        placeholder=""
                        value={addMoneyAmount}
                        ref={addMoneyAmountRef}
                        onChange={(e) => setAddMoneyAmount(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">select Amount</p>
                  <select
                    className="input"
                    ref={addMoneyAmountMethodRef}
                    onChange={(e) => setAddMoneyAmountMethod(e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="Visa Card">Visa Card</option>
                    <option value="Master Card">Master Card</option>
                  </select>
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>

      {/* Add new card */}
      <Model
        modelTitle="Add new card"
        width="md"
        onClose={() => setAddNewCard(false)}
        open={addNewCard}
        buttonTitle="Save"
        buttonHandler={AddNewCardHandler}
        loading={addNewCardLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Card holder name</p>
                  <input
                    type="text"
                    name="fullName"
                    className="input"
                    placeholder="card holder name"
                    value={cardHolderName}
                    ref={cardHolderNameRef}
                    onChange={(e) => setCardHolderName(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Account number</p>
                  <input
                    type="number"
                    name="number"
                    className="input"
                    placeholder="XXXX XXXX XXXX XXXX"
                    value={accountNumber}
                    ref={accountNumberRef}
                    onChange={(e) => setAccountNumber(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Expiry date</p>
                  <input
                    type="date"
                    className="input"
                    placeholder="dd/mm"
                    value={expiryDate}
                    ref={expiryDateRef}
                    onChange={(e) => setExpiryDate(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <div>
                  <p className="input-heading">cvv</p>
                  <input
                    type="number"
                    name="cvv"
                    className="input"
                    placeholder="xxx"
                    value={cvv}
                    ref={cvvRef}
                    onChange={(e) => setCvv(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default PurchasesProductMyCart;
